var _style, _defs, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAudioOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    width: 20,
    height: 20.381,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000048466173858331784560000017160927973083800727_);}\n\t.st1{fill:#00095B;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Group_966",
    transform: "translate(-3.781 -120.024)"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M16.2,130.9v6l-3.6-2.4l-0.9,0.9l5.7,3.8v-9.5L16.2,130.9z M11.4,129.6v-4.2l4.8-3.2v5.3l-5.7,5.6H7.3 c-0.9-2.3-0.9-4.9,0-7.2h3v4.8C10.9,130.8,11.4,130.3,11.4,129.6L11.4,129.6 M10.2,124.8H6.6L6.4,125c-1.4,2-1.4,7.1,0,9.1 l0.2,0.2h2.7l-4.8,4.8l0.8,0.8L23,122.4l-0.8-0.8l-4.8,4.8V120L10.2,124.8z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible",
      fill: "#00095B"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000044861605997246854850000017649911742602207409_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_965",
    transform: "translate(3.781 120.024)",
    style: {
      clipPath: "url(#SVGID_00000044861605997246854850000017649911742602207409_)"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_490",
    x: 0.3,
    y: -0.4,
    className: "st1",
    width: 19.3,
    height: 20.9
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioOff);
export default __webpack_public_path__ + "static/media/audioOff.030976b8f7fedbf4d0fe0aa0e42319ec.svg";
export { ForwardRef as ReactComponent };